import React from 'react';
import { useTranslation } from 'react-i18next';
import { rem, theme } from 'affiny-ui/src';
import { Flex, Text } from '../../primitives';

type Props = {
  className?: string;
  isMultiChoice?: boolean;
  maxChoices?: number;
  title?: string;
};

const DEFAULT_MAX_SELECTION = 3;

const ChipsListTitleWithSelection = ({
  className,
  isMultiChoice = false,
  maxChoices,
  title,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Flex
      borderBottom={[0, `1px solid ${theme.colors.gallery}`]}
      className={className}
      flexWrap="wrap"
      mb={theme.space.medium}
      pb={[0, 'medium']}
    >
      {title && (
        <Text
          fontWeight={600}
          fontSize={[rem(20), 'size24']}
          mr={theme.space.small}
        >
          {title}
        </Text>
      )}
      {isMultiChoice && (
        <Text color="secondary">
          {t('tagsSelect.max', { max: maxChoices ?? DEFAULT_MAX_SELECTION })}
        </Text>
      )}
    </Flex>
  );
};

export default ChipsListTitleWithSelection;
